import { curry } from 'lodash';

export function getTypedValue(type, value) {
    switch (type) {
        case 'number':
            return Number(value);
        case 'string':
            return String(value);
        case 'boolean':
            return Boolean(value);
        default:
            return '';
    }
}

function desc(a, b, orderBy, customOrderingRules = []) {
    switch (true) {
        case typeof a[orderBy] === typeof b[orderBy] && typeof a[orderBy] === 'number':
            a = a[orderBy];
            b = b[orderBy];
            break;
        case typeof a[orderBy] === typeof b[orderBy] && typeof a[orderBy] === 'string':
            a = a[orderBy] ? a[orderBy].toLowerCase() : '';
            b = b[orderBy] ? b[orderBy].toLowerCase() : '';
            break;
        case typeof a[orderBy]?.name === 'string':
            a = a[orderBy]?.name ? a[orderBy].name.toLowerCase() : '';
            b = b[orderBy]?.name ? b[orderBy].name.toLowerCase() : '';
            break;
        default:
            a = a[orderBy] ? a[orderBy].toString().toLowerCase() : '';
            b = b[orderBy] ? b[orderBy].toString().toLowerCase() : '';
            break;
    }

    customOrderingRules.forEach(rule => {
        if (orderBy === rule.name) {
            if (rule.ignoreCase) {
                a = a.toLowerCase();
                b = b.toLowerCase();
            }
            if (rule.type) {
                a = getTypedValue(rule.type, a);
                b = getTypedValue(rule.type, b);
            }
        }
    });

    if (typeof a === 'string') return hardCompareStrings(a, b);

    return simpleCompare(a, b);
}

function simpleCompare(a, b) {
    if (b < a) {
        return -1;
    }
    if (b > a) {
        return 1;
    }
    return 0;
}

function hardCompareStrings(a, b) {
    const chartsArrA = a.split(/[\s,.]+/);
    const chartsArrB = b.split(/[\s,.]+/);

    /**
     * if at least one of the arrays has no digits, we make a simple string comparison
     */
    if (!chartsArrA.some(element => !isNaN(Number(element))) || !chartsArrB.some(element => !isNaN(Number(element))))
        return simpleCompare(a, b);

    const minLength = chartsArrA.length <= chartsArrB.length ? chartsArrA.length : chartsArrB.length;
    for (let i = 0; i < minLength; i++) {
        const c1 = Number(chartsArrA[i]);
        const c2 = Number(chartsArrB[i]);
        switch (true) {
            case c1 > c2:
                return -1;
            case c1 < c2:
                return 1;
            case c1 === c2:
                break;
            default:
                const compareResult = simpleCompare(chartsArrA[i], chartsArrB[i]);
                if (compareResult) return compareResult;
                break;
        }
    }
}

export function getSorting(order, orderBy, customOdreringRules = []) {
    return order === 'desc'
        ? (a, b) => desc(a, b, orderBy, customOdreringRules)
        : (a, b) => -desc(a, b, orderBy, customOdreringRules);
}

function StableSortInternal(cmpFunction, array) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmpFunction(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

export const stableSort = curry(StableSortInternal);

export function getDataModification(dataArray, withFullName = false) {
    return dataArray.reduce((accumulator, currentValue) => {
        const versionNumberStartIndex = currentValue.name.search(/[\d.]+$/);
        const versionNumber = currentValue.name.substring(versionNumberStartIndex, currentValue.name.length);
        const osName = currentValue.name.substring(0, versionNumberStartIndex - 1);
        const newItem = { value: currentValue.id, label: withFullName ? currentValue.name : versionNumber };
        accumulator.hasOwnProperty(osName) ? accumulator[osName].push(newItem) : (accumulator[osName] = [newItem]);
        return accumulator;
    }, {});
}
